import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../services/api";
import { setToastOk } from "../main/mainSlice";

const initialState = {
  permissions: undefined,
  permissionDetail: undefined,
  currentPage: 1,
  itemsPerPage: 10,
  totalPages: 0,
  query: {},
};

export const fetchPermissions = createAsyncThunk(
  "permissions/fetchPermissions",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      var query = "";
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          if (query !== "") {
            query += `&`;
          }
          query += `${key}=${data[key]}`;
        }
      });
      const response = await api.get(`/permissions/search?${query}`);
      return response.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const fetchPermissionDetail = createAsyncThunk(
  "permissions/fetchPermissionDetail",
  async ({ _id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`/permissions/${_id}`);
      return response.data.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const createPermission = createAsyncThunk(
  "permissions/createPermission",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/permissions`, payload);
      dispatch(
        setToastOk({
          isOk: true,
          messages: response.data.message,
        }),
      );

      return response.data.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const editPermission = createAsyncThunk(
  "permissions/editPermission",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.patch(`/permissions/${payload._id}`, payload);
      dispatch(
        setToastOk({
          isOk: true,
          messages: response.data.message,
        }),
      );

      return response.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const deletePermission = createAsyncThunk(
  "permissions/deletePermission",
  async ({ permissionsId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.delete(`/permissions/${permissionsId}`);
      dispatch(
        setToastOk({
          isOk: true,
          messages: response.data.message,
        }),
      );
      return response.data;
    } catch (error) {
      dispatch(
        setToastOk({
          isOk: false,
          messages: error.response.data,
        }),
      );
      return rejectWithValue(error.response.data);
    }
  },
);

export const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    removePermission: (state, action) => {
      state.permissionDetail = undefined;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setQuery: (state, action) => {
      state.query = action.payload;
    },
  },
  extraReducers: (permissions) => {
    permissions
      .addCase(fetchPermissions.pending, (state) => {})
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.permissions = action.payload.data;
        state.totalPages = action.payload.pagination.totalPages;
      })
      .addCase(fetchPermissions.rejected, (state, action) => {})
      .addCase(fetchPermissionDetail.pending, (state) => {})
      .addCase(fetchPermissionDetail.fulfilled, (state, action) => {
        state.permissionDetail = action.payload;
      })
      .addCase(fetchPermissionDetail.rejected, (state, action) => {})
      .addCase(createPermission.pending, (state) => {})
      .addCase(createPermission.fulfilled, (state, action) => {
        state.permissions = state.permissions
          ? [action.payload, ...state.permissions]
          : [action.payload];
      })
      .addCase(createPermission.rejected, (state, action) => {})
      .addCase(editPermission.pending, (state) => {})
      .addCase(editPermission.fulfilled, (state, action) => {
        const editedPermission = action.payload;
        state.permissions?.forEach((permission) => {
          if (permission._id === editedPermission._id) {
            Object.keys(permission).forEach((key) => {
              permission[key] = editedPermission[key];
            });
          }
        });
      })
      .addCase(editPermission.rejected, (state, action) => {})
      .addCase(deletePermission.pending, (state) => {})
      .addCase(deletePermission.fulfilled, (state, action) => {
        const deletedId = action.payload._id;
        state.permissions = state.permissions?.filter(
          (permission) => permission._id !== deletedId,
        );
      })
      .addCase(deletePermission.rejected, (state, action) => {});
  },
});

export const { removePermission, setCurrentPage, setQuery } =
  permissionsSlice.actions;

export default permissionsSlice.reducer;
